import axios from 'axios';
import { BASE_URL } from 'utils/constants/Api';

import { IAutocompleteRequest } from '@project44-models/shipment-list';

async function fetchSuggestions(body: IAutocompleteRequest) {
  const data = await axios.post(`${BASE_URL}/autocomplete`, body, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return data?.data;
}

export default fetchSuggestions;
